import { useEffect, useState } from "react";
import crudApi from "@serie3/common/api/crudApi";
import ProfileConfig from "@serie3/freelancesplaceapi/Config/Profiles/ProfileConfig";

const ProfilePicture = ({ profileId, pictureSize = "128px", rerender }) => {
  const [proifilePicture, setProfilePicture] = useState(false);

  useEffect(() => {
    const fetchPicture = async () => {
      let previewUrl = ProfileConfig.endpoints.profilePicture + profileId;
      const response = await crudApi.getBinary(previewUrl);
      if (response.status === 200) {
        let file = {
          header: response.headers,
          data: response.data,
        };
        const url = window.URL.createObjectURL(response.data);
        setProfilePicture(url);
      } else {
        setProfilePicture(null);
      }
    };

    fetchPicture();
  }, [profileId, rerender]);

  const PictureDummy = () => {
    return (
      <div
        style={{
          width: pictureSize,
          height: pictureSize,
          borderRadius: "50%",
          backgroundColor: "lightgrey",
          justifyContent: "center",
          alignItems: "center",
          verticalAlign: "middle",
          display: "inline-flex",
        }}
      >
        <span
          style={{ color: "grey", fontWeight: "bolder", fontSize: "small" }}
        >
          No Picture uploaded
        </span>
      </div>
    );
  };

  return proifilePicture ? (
    <img
      src={proifilePicture}
      alt="user-avatar"
      className="img-circle img-fluid"
      style={{ width: pictureSize, height: pictureSize }}
    />
  ) : (
    <PictureDummy />
  );
};

export default ProfilePicture;
